import React from 'react';
import { Box, Typography, Chip } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import SectionHeading from '../home/SectionHeading';
import { useInView, reveal } from '../home/motion';
import { useT } from '../../i18n/LanguageContext';

// The book names three structured ways to run a session with the deck.
// Two of them are literally the mentor's guided modes on this platform
// (mappatura, scenari_futuri) — a true product tie-in, not a marketing claim.
function getApproaches(t) {
  return [
    {
      name: t('method.approaches.approach1Name'),
      text: t('method.approaches.approach1Text'),
      tag: null,
    },
    {
      name: t('method.approaches.approach2Name'),
      text: t('method.approaches.approach2Text'),
      tag: t('method.approaches.approach2Tag'),
    },
    {
      name: t('method.approaches.approach3Name'),
      text: t('method.approaches.approach3Text'),
      tag: t('method.approaches.approach3Tag'),
    },
  ];
}

export default function MethodApproaches() {
  const theme = useTheme();
  const t = useT();
  const { ref, visible } = useInView();
  const APPROACHES = getApproaches(t);

  return (
    <Box sx={{ bgcolor: theme.home.paper, py: theme.home.sectionPy }}>
      <Box sx={{ maxWidth: theme.home.maxWidth, mx: 'auto', px: { xs: 3, md: 5 } }}>
        <SectionHeading
          eyebrow={t('method.approaches.eyebrow')}
          accent={theme.home.coralText}
          title={t('method.approaches.title')}
          lede={t('method.approaches.lede')}
        />
        <Box ref={ref} sx={{ mt: { xs: 4, md: 6 }, display: 'flex', flexDirection: 'column', gap: 3 }}>
          {APPROACHES.map((a, i) => (
            <Box key={a.name} sx={{
              display: 'flex', gap: { xs: 2, md: 3 }, alignItems: 'flex-start',
              borderBottom: i < APPROACHES.length - 1 ? `1px solid ${theme.home.paperDeep}` : 'none',
              pb: 3, ...reveal(visible, 0.08 * i),
            }}>
              <Typography sx={{
                fontFamily: theme.home.display, fontWeight: 900, fontSize: '2.2rem',
                color: theme.home.paperDeep, WebkitTextStroke: `1.5px ${theme.home.cyanText}`,
                lineHeight: 1, minWidth: { xs: 40, md: 56 },
              }}>
                {String(i + 1).padStart(2, '0')}
              </Typography>
              <Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap' }}>
                  <Typography sx={{ fontFamily: theme.home.display, fontWeight: 700, fontSize: '1.25rem', color: theme.home.ink }}>
                    {a.name}
                  </Typography>
                  {a.tag && (
                    <Chip
                      label={a.tag} size="small"
                      sx={{ bgcolor: theme.home.cyanText, color: '#fff', fontWeight: 600, fontSize: '0.7rem' }}
                    />
                  )}
                </Box>
                <Typography sx={{ mt: 0.75, color: theme.home.inkMuted, lineHeight: 1.6, maxWidth: 620 }}>
                  {a.text}
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
}
